module.exports = __webpack_public_path__ + "static/img/login-logo.c157c31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-logo.png
// module id = ak46
// module chunks = 1